export const DEFAULT_COMMENT_LIMIT = null; 
export const DEFAULT_COMMENT_SORT = "-date"
export const DEFAULT_PAGE = 1